import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { BreadType } from 'types/bread'
import { DeliveryStock } from 'types/stock'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { subMinutes } from 'date-fns'
import { parseToDate } from 'lib/helper'

const getInitialDeliveryStock = (
  bread: BreadType,
  breadRef: FirebaseDocRefType,
  strDate: string,
  stockRef: FirebaseDocRefType | undefined,
  storeDeliveryBread: StoreDeliveryBreadType,
  storeName: string,
  storeRef: FirebaseDocRefType
): DeliveryStock => {
  const {
    hours_to_deadline,
    maximum_order,
    package_size,
    delivery_company,
    frozen_delivery_type,
    is_frozen_delivery,
    how_to_eat,
    how_to_store,
    choices,
  } = storeDeliveryBread
  const deadline = FirebaseTimestamp.fromDate(subMinutes(parseToDate(strDate), hours_to_deadline * 60))
  return {
    bread_ref: breadRef,
    bread_name: bread.name,
    date: strDate,
    choices,
    deadline,
    delivery_company,
    frozen_delivery_type,
    how_to_eat,
    how_to_store,
    image_url: bread.image_urls[0] || '',
    is_deleted: false,
    is_frozen_delivery,
    last_notified_time: null,
    maximum_order: 1,
    note: '',
    options: [],
    package_size,
    pickupable_time: '00:00',
    price: bread.price,
    stock: maximum_order,
    stock_ref: stockRef,
    store_name: storeName,
    store_ref: storeRef,
    type: 'delivery',
  }
}

export default getInitialDeliveryStock
